import { useAuth } from '../contexts/AuthContext';
import { useWorkspace } from '../contexts/WorkspaceContext';

/**
 * La puerta de arranque de las consultas de datos: el taller activo y si ya se
 * puede consultar.
 *
 * `activeWorkspace` NUNCA es nulo: WorkspaceContext cae en `FALLBACK_PROFILES[0]`,
 * cuyo id es literalmente la cadena 'default'. Por eso `!!activeWorkspace?.id`
 * no era ninguna puerta — dejaba consultar un taller inexistente antes de que el
 * de verdad resolviera, y cero filas de un taller que no existe se guardan como
 * éxito. La condición buena es taller RESUELTO y distinto de 'default'.
 *
 * Contrapartida, a propósito: si WorkspaceContext se rinde (`status === 'error'`)
 * estas consultas se quedan apagadas en vez de tirar del id del localStorage.
 * Pantalla en blanco con reintento antes que pantalla con los datos de otro.
 *
 * Vivía copiada en cuatro archivos de hooks (proyectos, flota, servicios,
 * reloj), y los de estimados —estimados, precios, plantillas— seguían con la
 * puerta vieja: eran las tres consultas que disparaban aunque el taller
 * estuviera en `'error'`, y las que más informes dejaron cuando una sesión se
 * perdió por debajo de la app. Una sola copia, para todos.
 */
export function useTallerListo() {
    const { isAuthorized } = useAuth();
    const { activeWorkspace, status } = useWorkspace();
    const wsId = activeWorkspace?.id || 'default';
    return { wsId, listo: isAuthorized && status === 'resolved' && wsId !== 'default' };
}
